import {
  placeholderImage,
  placeholderHtml,
} from '../../utils/helperPlaceholder';

import {
  buildMenuTree,
  flattenCustomImage,
  transformCta,
  toRelativeUrl,
} from '../../utils/helperTransforms.wp';
// Recursively normalise a footer menu item (and its children) so every level
// exposes a flat `featuredImage` — mirrors NavigationMain's mapMenuItem minus
// the excerpt (footer hover-image only needs the image).
function mapMenuItem(item) {
  return {
    ...item,
    featuredImage:
      flattenCustomImage(item.connectedNode?.node?.featuredImage) || null,
    children: Array.isArray(item.children) ? item.children.map(mapMenuItem) : [],
  };
}

function transformLocationLink(link) {
  if (!link?.url) return false;

  return {
    url: toRelativeUrl(link.url),
    title: link.title || false,
  };
}

function transformFooterGravityFormId(gravityFormId) {
  const parsedFormId = parseInt(gravityFormId, 10);
  return Number.isInteger(parsedFormId) && parsedFormId > 0
    ? String(parsedFormId)
    : false;
}

export function transformNavigationFooter(data) {
  return {
    // menu: buildMenuTree(data?.footerMenu?.menuItems?.nodes || []),
    menu: buildMenuTree(data?.footerMenu?.nodes || []).map(mapMenuItem),
    menuLegal: buildMenuTree(data?.menuLegal?.nodes || []),
    menuSocial: buildMenuTree(data?.menuSocial?.nodes || []),
    site: {
      link: '/',
      title: data?.generalSettings?.title || 'Site title',
    },
    // heading:
    //   data?.globalOptionsDefault?.globalNavigationfooter
    //     ?.global_navigationfooter_heading || false,
    // content:
    //   data?.globalOptionsDefault?.globalNavigationfooter
    //     ?.global_navigationfooter_content || false,
    // address:
    //   data?.globalOptionsDefault?.globalNavigationfooter
    //     ?.global_navigationfooter_address || false,
    // abn:
    //   data?.globalOptionsDefault?.globalNavigationfooter
    //     ?.global_navigationfooter_abn || false,
    cta: transformCta(
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_cta
    ),
    socialLabel:
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_labels?.socialAriaLabel || false,
    legalLabel:
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_labels?.legalAriaLabel || false,
    menuLabel:
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_labels?.ariaLabel || false,
    // logo:
    //   data?.globalOptionsDefault?.globalNavigationfooter
    //     ?.global_navigationfooter_logoimage?.node?.sourceUrl || false,
    siteTitle: data?.generalSettings?.title || '',
    copyright:
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_copyright || false,
    locationHeading:
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_location_heading || false,
    locationLink: transformLocationLink(
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_location_link
    ),
    gravityFormId: transformFooterGravityFormId(
      data?.globalOptionsDefault?.globalNavigationfooter
        ?.global_navigationfooter_gravity_form_id
    ),
  };
}

export const DEMO_DATA = [
  {
    type: 'navigation-footer',
  },
];
